/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconBurger = StyledIconInline.extend`
  height: ${props => props.height || '16px'};
  width: ${props => props.width || '22px'};
`;

export const IconBurger = (props) => (
    <StyledIconBurger {...props}>
        <svg viewBox="0 0 22 15" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21.4751,0.4966 L0.5181,0.4966"/>
                <path d="M21.4751,7.4985 L0.5181,7.4985"/>
                <path d="M21.4751,14.5 L0.5181,14.5"/>
            </g>
        </svg>
    </StyledIconBurger>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconBurger/index.js